import { render, staticRenderFns } from "./DiffusionExpress.vue?vue&type=template&id=c67ddf6e&"
import script from "./DiffusionExpress.vue?vue&type=script&lang=ts&"
export * from "./DiffusionExpress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports